module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "moreModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.moreText)
    }
  })])])])])]), _vm._v(" "), _c('div', {
    ref: 'ellipsis' + this.random,
    class: {
      'ellipsis-2-lines': _vm.showMore
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.moreText)
    }
  })]), _vm._v(" "), (_vm.showMore) ? _c('a', {
    staticClass: "text-primary show-more",
    attrs: {
      "data-target": "#moreModal",
      "data-toggle": "modal"
    }
  }, [_vm._v("\n    ...更多\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf85731"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/More.vue
// module id = 2472
// module chunks = 1